/**
 * Portfolio tab — placeholder until ECAS extraction ships.
 * Today shows a "coming soon" card; the upload button is disabled because
 * `ecas` isn't yet in /profile/document-types/supported.
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@finmin/ui';
import { TrendingUp, Sparkles } from 'lucide-react';

export function PortfolioTab() {
  return (
    <div className="space-y-5">
      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <TrendingUp className="h-4 w-4 text-muted-foreground" aria-hidden />
            Investment portfolio
          </CardTitle>
          <CardDescription>
            Mutual fund holdings and SIPs, parsed from your NSDL/CDSL ECAS
            statement.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-lg border border-dashed border-border bg-secondary/30 py-10 text-center">
            <Sparkles
              className="mx-auto h-8 w-8 text-muted-foreground/60"
              aria-hidden
            />
            <p className="mt-3 text-sm font-medium text-foreground">
              Coming soon
            </p>
            <p className="mt-1 text-xs text-muted-foreground max-w-md mx-auto">
              We're wiring up our ECAS parser. Once it's live, upload your monthly
              statement here and we'll show your folios, schemes, and 12-month
              portfolio history.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
